import { SelectDefinition } from './select-definition';
import { TemplateArea } from './template-area';
export class Template {

  id: number;
  nameDictionaryKey: string;
  source: string;
  areas: TemplateArea[] = [];
  titlePattern: string;
  selectDefinitions = new Array<SelectDefinition>();

  constructor(template: any) {

    this.id = template.id;
    this.nameDictionaryKey = template.nameDictionaryKey;
    this.source = template.source;

    if (template.areas != null) {
      for (const area of template.areas) {
        this.areas.push(new TemplateArea(area));
      }
    }

    if (template.selectDefinitions != null) {
      for (const sd of template.selectDefinitions) {
        this.selectDefinitions.push(new SelectDefinition(sd));
      }
    }

    this.titlePattern = template.titlePattern;
  }

}
